function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import UncoveredOverlayModal from "../../modal/UncoveredOverlayModal";
import TmDeleteField from "./TmDeleteField";

class TmOverlayFieldDeleteModal extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UncoveredOverlayModal, {
        modalStyle: {
          width: '14rem'
        },
        trigger: this.props.trigger,
        content: /*#__PURE__*/React.createElement(TmDeleteField, {
          onClear: this.props.onClear
        }),
        title: 'Delete'
      }));
    });
  }

}

export default TmOverlayFieldDeleteModal;